<template>
  <div id="app">
    <router-view />
    <GlobalPdfGenerator />
  </div>
</template>

<script>
import GlobalPdfGenerator from '@/components/GlobalPdfGenerator.vue'

export default {
  name: 'App',
  components: {
    GlobalPdfGenerator
  },
  mounted() {
    const activityEvents = ['mousedown', 'keydown', 'scroll', 'touchstart'];
    let lastUpdate = 0;
    const updateActivity = () => {
      const now = Date.now();
      // Throttle store update to once every 10 seconds to avoid overhead
      if (now - lastUpdate > 10000) {
        lastUpdate = now;
        if (this.$store && this.$store.state.auth && this.$store.state.auth.isAuthenticated) {
          this.$store.commit('auth/updateLastActive');
        }
      }
    };
    activityEvents.forEach(event => {
      window.addEventListener(event, updateActivity, { passive: true });
    });
    
    // Periodic token refresh check for active users on the same page (every 1 minute)
    const refreshInterval = setInterval(() => {
      if (this.$store && this.$store.state.auth && this.$store.state.auth.isAuthenticated) {
        const lastActive = this.$store.state.auth.lastActive;
        if (lastActive) {
          const timeoutMinutes = process.env.VUE_APP_SESSION_TIMEOUT_MINUTES ? parseInt(process.env.VUE_APP_SESSION_TIMEOUT_MINUTES) : 45;
          const idleTimeoutMs = timeoutMinutes * 60 * 1000;
          const now = Date.now();
          if (now - lastActive <= idleTimeoutMs) {
            // User is active, check token expiry
            const tokenExpiry = this.$store.state.auth.tokenExpiry;
            if (tokenExpiry) {
              const expiryMs = new Date(tokenExpiry).getTime();
              const timeToExpiryMs = expiryMs - now;
              // If token expires in less than 30 minutes (and not already completely expired)
              if (timeToExpiryMs > 0 && timeToExpiryMs < 30 * 60 * 1000) {
                this.$store.dispatch('auth/refreshToken');
              }
            }
          }
        }
      }
    }, 60000);
    
    this._cleanupActivity = () => {
      activityEvents.forEach(event => {
        window.removeEventListener(event, updateActivity);
      });
      clearInterval(refreshInterval);
    };
  },
  beforeUnmount() {
    if (this._cleanupActivity) {
      this._cleanupActivity();
    }
  }
}
</script>